import React, { Component } from 'react';
import './styles.css';

export default class Messages extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Messages Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Messages/Messages.js